import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const InvitePreview = () => {
    const [isFlipped, setIsFlipped] = useState(false);
    const navigate = useNavigate();

    // Auto flip animation per attirare l'attenzione
    useEffect(() => {
        const interval = setInterval(() => {
            setIsFlipped(prev => !prev);
        }, 3000); // Flip ogni 3 secondi

        return () => clearInterval(interval);
    }, []);

    const handleClick = () => {
        window.open('/online', '_blank');
    };

    return (
        <div className="invite-preview-section">
            <div className="invite-preview-container">
                <div className="invite-preview-content">
                    <div className="preview-text">
                        <h3 className="preview-title">Partecipazione Digitale</h3>
                        <p className="preview-description">
                            E se vuoi avere la partecipazione sempre a portata di mano, 
                            <br />
                            <span className="preview-highlight">Apri la versione digitale!</span>
                        </p>
                    </div>
                    
                    <div className="preview-card-wrapper" onClick={handleClick}>
                        <div className={`preview-flip-container ${isFlipped ? 'flipped' : ''}`}>
                            {/* Front side */}
                            <div className="preview-flip-front">
                                <img 
                                    src="/assets/img/invite-page1.jpg" 
                                    alt="Anteprima Partecipazione" 
                                    className="preview-invite-image"
                                />
                            </div>
                            
                            {/* Back side */}
                            <div className="preview-flip-back">
                                <img 
                                    src="/assets/img/invite-page2.jpg" 
                                    alt="Anteprima Partecipazione - Retro" 
                                    className="preview-invite-image"
                                />
                            </div>
                        </div>
                        
                        <div className="preview-cta">
                            <span className="preview-button">
                                <span className="button-icon">📱</span>
                                <span className="button-text">Visualizza Online</span>
                                <span className="button-arrow">→</span>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default InvitePreview; 